export class Timeline {
    timelineId: string;
    appointmentNo: string;
    timelineActionName: string;
    timelineActionId: number;
    description: string;
    createdByName: string;
    fullName: string;
    data: string;
    showCase: string;
    createdDate: Date;
    timelineDataId: number;
    viewLoading: boolean;
    totalItems: number;
    providerName: string;
    specializationName: string;
    visitorName: string;
    documentName: string;
    documentType: string;
    appointmentDate: Date;
}